export enum AttachDocumentType {
  GENERAL = 'General',
  MANUAL = 'Manual',
  PACKING_INSTRUCTIONS = 'Packing instructions',
  PACKING_LIST = 'Packing list',
  CERTIFICATES_OF_ORIGIN = 'Certificates of origin',
  DANGEROUS_GOODS_FORMS = 'Dangerous goods forms',
  INVOICE = 'Invoice',
  CERTIFICATE = 'Certificate',
  PROFORMA_INVOICE = 'Proforma invoice',
  PROOF_DELIVERY = 'Proof of delivery',
  PACKAGING_INSTRUCTION = 'Packaging instruction',
  PROOF_OF_PAYMENT = 'Proof of payment',
}
